export const useTenantLink = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;
  const isLocal = hostname.includes('localhost') || /^[0-9.]+$/.test(hostname);

  const getTenantLink = (path = '/', tenant) => {
    if (isLocal) {
      return `${protocol}//${hostname}:${port}/?tenant=${tenant}&path=${path}`;
    }
    const parts = hostname.split('.');
    parts[0] = tenant;
    const newHost = parts.join('.');
    return `${protocol}//${newHost}${path}`;
  };

  return getTenantLink;
};